// /src/API/api.js
import axios from 'axios';
import BASE_URL from './config';

// إعداد axios instance
const api = axios.create({
  baseURL: BASE_URL,
});

// Interceptor لإضافة التوكن إلى كل طلب
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Adding Authorization header:', config.headers.Authorization);
    } else {
      console.warn('No token found in localStorage for request:', config.url);
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

export default api;